export enum EditorMode {
  WYSIWYG = 'wysiwyg',
  SOURCE = 'source',
}
